import humanizeString from "string-humanize";
const createDataColumn = (key, options = {}) => (Object.assign({ id: key, accessorKey: key, header: () => humanizeString(key), cell: (data) => data.getValue() }, options));
export default createDataColumn;
//# sourceMappingURL=dataColumn.js.map